<script>

import {startDispatch} from "@/api/operation_modules/pickup";
import XLSX from "xlsx";

export default {
  name: "dispatchShipment",
  data() {
    return {
      formItem: {
        agentSelector: 'AE-FFC',
        arguments: []
      },
      loading: false,
      columns: [
        { type: 'index', width: 60, align: 'center' },
        { title: '订单号', key: 'shipmentNumber', width: 140, align: 'center' },
        { title: '代理名称', key: 'agentName', width: 140, align: 'center' },
        { title: '代理单号', key: 'agentNumber', width: 150, align: 'center' },
        { title: '状态提示', key: 'tips', headerAlign: 'center'}
      ],
      data: [],
      file: null,
      sheetSelector: [],
      columnSelector: [],
      selector: {
        sheetName: '',
        columnName: '',
        recordSize: 0
      },
    }
  },
  watch: {
    'selector.sheetName'(newVal, oldVal) {
      const matched = this.sheetSelector.find(v => v.sheetName === newVal)
      this.columnSelector = matched.header;
      this.selector.recordSize = matched.maxRow
    },
    'selector.columnName'(newVal, oldVal) {
      // 假设用户选了文件
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // 1. 获取第一个 Sheet
        const worksheet = workbook.Sheets[this.selector.sheetName];

        // 2. 读取第 0 列 (A列) 从第二行开始的数据
        this.formItem.arguments = this.getColumnData(worksheet, newVal);
      };
      reader.readAsArrayBuffer(this.file);
    }
  },
  methods: {
    handleScan() {
      this.dispatch()
    },
    handleUpload(file) {
      this.file = file
      // 开始读取工作表和首行
      const reader = new FileReader();

      reader.onload = e => {
        // 1. 读取文件内容 (ArrayBuffer 格式)
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const finalResults = [];

        // 2. 遍历所有 Sheet
        workbook.SheetNames.forEach(sheetName => {
          const worksheet = workbook.Sheets[sheetName];

          // 获取 Sheet 的有效范围数据
          const ref = worksheet['!ref'];

          let maxRow = 0;
          let firstRow = [];

          if (ref) {
            // 3. 解析范围 (例如 "A1:E10")
            const range = XLSX.utils.decode_range(ref);

            // 4. 获取最大记录行号 (range.e.r 是终止行索引，从0开始)
            maxRow = range.e.r + 1;

            // 5. 读取首行 (即 index 为 range.s.r 的那一行)
            const startRowIndex = range.s.r; // 起始行索引
            for (let c = range.s.c; c <= range.e.c; c++) {
              const cellAddress = XLSX.utils.encode_cell({ r: startRowIndex, c: c });
              const cell = worksheet[cellAddress];
              // cell.v 是原始值，cell.w 是格式化后的文本
              firstRow.push(cell ? cell.v : null);
            }
          }

          finalResults.push({
            sheetName: sheetName,
            maxRow: maxRow - 1,
            header: firstRow
          });
        });

        // 打印结果到页面
        this.sheetSelector = finalResults;
      };

      reader.readAsArrayBuffer(file);
      return false
    },
    dispatch() {
      if (this.formItem.agentSelector === '') {
        this.$Message.error('请选择合适的分货代理')
        return;
      }
      if (this.formItem.arguments.length <= 0) {
        this.$Message.error('请选择要分货的订单号码后继续')
        return;
      }
      // 开始提交
      this.loading = true
      startDispatch(this.formItem).then(response => {
        this.loading = false
        if (response.data.code === 0) {
          this.$Message.success(response.data.msg)
        } else {
          this.$Message.warning(response.data.msg)
        }
      })
    },
    removeItem(itemValue) {
      this.formItem.arguments = this.formItem.arguments.filter(v => v !== itemValue);
    },
    getColumnData(worksheet, colIndex) {
      const data = [];
      const ref = worksheet['!ref'];

      if (!ref) return data;

      const range = XLSX.utils.decode_range(ref);

      // 从第二行开始遍历 (索引为 1)
      // range.s.r 是起始行，通常为 0，但如果前几行全空，s.r 可能会大于 0
      // 我们取 Math.max(range.s.r + 1, 1) 确保从第二行（索引1）或实际起始行的下一行开始
      const startRow = Math.max(range.s.r + 1, 1);
      const endRow = range.e.r;

      for (let r = startRow; r <= endRow; r++) {
        // 构建单元格地址，例如：{r: 1, c: 0} -> "A2"
        const cellAddress = XLSX.utils.encode_cell({ r: r, c: colIndex });
        const cell = worksheet[cellAddress];

        // 过滤掉空格、null、undefined
        // cell.v 是原始值，如果是字符串，顺便 trim() 一下防止只有空格的字符串
        if (cell && cell.v !== null && cell.v !== undefined && cell.v !== "") {
          let value = cell.v;

          // 如果是字符串，过滤掉纯空格的情况
          if (typeof value === 'string' && value.trim() === "") {
            continue;
          }

          data.push(value);
        }
      }

      return data;
    }
  }
}
</script>

<template>
  <Card>
    <Row :gutter="32">
      <Col :span="6">
        <Form :model="formItem" :label-width="160" @submit.native.prevent>
          <FormItem label="代理名称">
            <Select v-model="formItem.agentSelector" :disabled="loading">
              <Option value="AE-FFC">AE FFC</Option>
              <Option value="AE-ECO">AE ECO</Option>

              <Option value="BH-ECO">BH ECO</Option>
              <Option value="SA-ECO">SA ECO</Option>

              <Option value="KW-Anderson">KW Anderson</Option>
            </Select>
          </FormItem>

          <FormItem label="订单号码">
            <Upload
              :before-upload="handleUpload"
              action="">
              <Button icon="ios-cloud-upload-outline">选择文件</Button>
            </Upload>
            <div v-if="file !== null">选择的文件为: {{ file.name }}</div>
          </FormItem>

          <FormItem label="工作表">
            <Select v-model="selector.sheetName">
              <Option v-for="(item, kx) in sheetSelector" :value="item.sheetName" :label="item.sheetName"></Option>
            </Select>
          </FormItem>

          <FormItem label="所在列">
            <Select v-model="selector.columnName">
              <Option v-for="(item, kx) in columnSelector" :value="kx" :label="item"></Option>
            </Select>
          </FormItem>

          <FormItem label="数据量">
            <Input v-model="selector.recordSize" readonly></Input>
          </FormItem>

          <FormItem>
            <Button type="primary" @click="dispatch" :loading="loading">开始分货</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :span="18">
        <div style="height: 600px; overflow-y: scroll;">
          <Tag v-for="item in formItem.arguments" size="large" type="dot" closable color="primary" @on-close="removeItem(item)">{{ item }}</Tag>
        </div>
      </Col>
    </Row>
  </Card>
</template>

<style scoped>

</style>
